import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { PageErrorBoundary } from '@vivicta/ui';

const repositoryVisualizerPage = PageBlueprint.make({
  params: {
    path: '/repository-map',
    noHeader: true,
    loader: () =>
      import('./components/RepositoryVisualizerPage').then(m => (
        <PageErrorBoundary title="Repository Map">
          <m.RepositoryVisualizerPage />
        </PageErrorBoundary>
      )),
  },
});

export default createFrontendPlugin({
  pluginId: 'vivicta-repository-visualizer',
  extensions: [repositoryVisualizerPage],
});
